const Colors = {
    transparent: 'transparent',
    background: '#F5F2F6',
    white: '#ffffff',
    white50: '#ffffff50',
    black: '#201628',
    accent1: '#55217E',
    accent1_dark: '#371057',
    accent2: '#066D54',
    accent2_dark: '#054B3A',
    greyDark: '#49454F',
    grey: '#736A85',
    greyLight: '#CAC4D0',
    light: '#F5F2F6',
    disabledColor: '#AAA6AE',
    disabledBg: '#ECE9F0',
    violet: '#EAE4EF',
    EAE4EFaccentViolet: '#CAC4D0',
    red: '#FEE8E7',
    accentRed: '#C83532',
    green: '#F7FFF6',
    accentGreen: '#32BB5B',
    orange: '#FEF6E7',
    accentOrange: '#FE5C26',
    yellow: '#FFB508',
    notification1: '#FFB508',
    notification2: '#2738AA',
    blue: '#2CBEDF'
}

export default Colors
